import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SouthWestIcon(props: IconProps) {
    return <Icon {...props} iconKey={"south_west"}/>
}
